/**
 * Logique pure du bloc Onglets. Le rendu et les champs s'appuient dessus, mais
 * rien ici ne connaît React ni Puck — d'où le test colocalisé.
 */

/** Zone Puck d'un onglet, telle que la voit une DropZone (`zone="..."`). */
export function tabZoneName(tabId) {
  return `tab-${tabId}`;
}

/**
 * Clé de la zone dans `data.zones`. Dérivée de l'id d'ONGLET, pas d'un id de
 * bloc : à la duplication du bloc Onglets, Puck régénère l'id du parent, donc
 * la clé change avec lui même si les onglets gardent leurs ids.
 */
export function tabZoneKey(blockId, tabId) {
  return `${blockId}:${tabZoneName(tabId)}`;
}

export function createTabId() {
  return `t-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

/**
 * Onglet à afficher. `requested` est l'onglet cliqué (état local du canvas),
 * `defaultTabId` le choix de la sidebar. Les deux peuvent désigner un onglet
 * supprimé entre-temps : on retombe alors sur le premier, jamais sur rien.
 * @returns {string|null} null seulement si la liste est vide.
 */
export function resolveActiveTabId(tabs, requested, defaultTabId) {
  const ids = (tabs || []).map((tab) => tab?.id).filter(Boolean);
  if (ids.length === 0) return null;
  if (requested && ids.includes(requested)) return requested;
  if (defaultTabId && ids.includes(defaultTabId)) return defaultTabId;
  return ids[0];
}

/**
 * Libellé lisible d'un onglet : le libellé est du texte riche (édité sur le
 * canvas), mais la sidebar et les `aria-label` ont besoin de texte nu.
 */
export function tabPlainLabel(tab, index) {
  const text = String(tab?.label || '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return text || `Onglet ${index + 1}`;
}

/** Justification de la barre d'onglets. */
export function tabsListJustify(align) {
  if (align === 'center') return 'center';
  if (align === 'right') return 'flex-end';
  return 'flex-start';
}
